import { gql, useMutation } from '@apollo/client';
import { DeleteSubjectMutation } from '../../__generated__/queries-topic';

const DELETE_SUBJECT = gql`
  mutation DeleteSubject($id: UUID!) {
    deleteSubject(where: { id: $id }) {
      id
    }
  }
`;

export const useSubjectDeleter = () =>
  useMutation<DeleteSubjectMutation>(DELETE_SUBJECT);
